import { APICore } from "./apiCore";

const api = new APICore();

const getRelatorioPulseSentimentos = (queryString?: string) => {
  return api.get(`/relatorio-pulse-sentimentos${queryString ? queryString : ""}`, {
    responseType: "blob",
  });
};

export { getRelatorioPulseSentimentos };
